import React from 'react';
import InputController from '@/components/inputController/index';
import { PERSONAL_DATA } from '@/constants/personalData';
import FormTemplate from '@/components/formTemplate/index';

function ContactData({ control, showTitle = true, step = null }) {
  const { TITLE_CONTACT_DATA, ID, EMAIL, CONTACT_PHONE } = PERSONAL_DATA;
  return (
    <div className="contact-data-container">
      <FormTemplate
        titleText={showTitle ? TITLE_CONTACT_DATA : ''}
        cyData={ID}
        step={step}
      >
        <InputController
          className="contact-data-container__input"
          inputName={EMAIL.NAME}
          inputId={EMAIL.ID}
          control={control}
          inputMode="email"
          rules={{
            required: EMAIL.RULES.REQUIRED,
            pattern: EMAIL.RULES.PATTERN.EMAIL_FORMAT,
            validate: (fieldValue) =>
              EMAIL.RULES.VALIDATE.EMAIL_DOMAIN.checkFunc(fieldValue) ||
              EMAIL.RULES.VALIDATE.EMAIL_DOMAIN.message,
          }}
          label={EMAIL.LABEL}
        />
        <InputController
          className="contact-data-container__input--last"
          inputName={CONTACT_PHONE.NAME}
          inputId={CONTACT_PHONE.ID}
          mask={CONTACT_PHONE.MASK}
          control={control}
          inputMode="numeric"
          rules={{
            required: CONTACT_PHONE.RULES.REQUIRED,
            validate: (fieldValue) =>
              CONTACT_PHONE.RULES.VALIDATE.CONTACT_PHONE_FORMAT.checkFunc(
                fieldValue
              ) || CONTACT_PHONE.RULES.VALIDATE.CONTACT_PHONE_FORMAT.message,
          }}
          label={CONTACT_PHONE.LABEL}
          info={CONTACT_PHONE.INFO}
        />
      </FormTemplate>
      <style jsx>
        {`
          .contact-data-container {
            margin-bottom: 12px;
            :global(.contact-data-container__input) {
              margin: 0px 0 8px 0px;
              width: 100%;
            }
            :global(.contact-data-container__input--last) {
              margin: 0px 0 0px 0px;
              width: 100%;
            }
          }
        `}
      </style>
    </div>
  );
}
export default ContactData;
